import { ToolCallResponse } from 'api/clients/AiClient'
import { cleanToolCalls } from '../utils/processToolCalls'

type Caption = { caption: string }

export const processToolCalls = (toolCalls: Array<ToolCallResponse>) => {
  let captions: Array<string> = []
  cleanToolCalls(toolCalls).forEach((toolCall) => {
    if (toolCall.function.name === 'generate_caption') {
      const caption = JSON.parse(toolCall.function.arguments) as Caption
      captions.push(caption.caption)
    }
  })

  if (!captions.length) throw new Error('No captions found in server response')

  return captions
}
